/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { CALL_API } from '../middleware';
import {
  GetDistributorCommitmentAmount,
  GetOnboardingCompletedDetailsReportResponse,
  GetOnboardingDetailsReportResponse,
  GetOnBoardingSummaryReportResponse,
  OnBoardingDetailReportType,
  ReportFilterType,
} from '../types/api-types';
import {
  ONBOARDING_SUMMARY_REPORT,
  ONBOARDING_SUMMARY_REPORT_SUCCESS,
  ONBOARDING_DETAIL_REPORT,
  ONBOARDING_DETAIL_REPORT_SUCCESS,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS,
  ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_SUMMARY_REPORT_DOWNLOAD,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS,
  DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT,
  DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS,
  ONBOARDING_COMPLETED_REPORT_DOWNLOAD,
  ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_COMPLETED_DETAIL_REPORT_DOWNLOAD,
  ONBOARDING_COMPLETED_DETAIL_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_COMPLETED_DETAIL_REPORT_SUCCESS,
  ONBOARDING_COMPLETED_DETAIL_REPORT,
  PennyDropLogs_REPORT_Download_SUCCESS,
  PennyDropLogs_REPORT_Download,
} from '../types/onBoarding';

const updatedFromAndToDates = (params: {
  from: string;
  to: string;
}): { from: string; to: string } => {
  const { from, to } = params;
  const fromDate = new Date(from);
  fromDate.setHours(0, 0, 0, 0);
  const toDate = new Date(to);
  toDate.setHours(23, 59, 59, 999);
  return { from: fromDate.toISOString(), to: toDate.toISOString() };
};

export const getOnBoardingSummary =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<GetOnBoardingSummaryReportResponse[]> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/onboardingSummary`,
        method: 'GET',
        types: [ONBOARDING_SUMMARY_REPORT, ONBOARDING_SUMMARY_REPORT_SUCCESS],
        params: { ...params, from, to },
      },
    });
  };

export const getOnBoardingDetails =
  (params: OnBoardingDetailReportType) =>
  async (dispatch: any): Promise<GetOnboardingDetailsReportResponse> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/onboardingDetails`,
        method: 'GET',
        types: [ONBOARDING_DETAIL_REPORT, ONBOARDING_DETAIL_REPORT_SUCCESS],
        params: {
          ...params,
          from,
          to,
        },
      },
    });
  };

export const getDistributorWiseOnBoardingSummary =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<GetOnBoardingSummaryReportResponse[]> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/distributorWiseOnboardingSummary`,
        method: 'GET',
        types: [
          DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT,
          DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS,
        ],
        params: {
          ...params,
          from,
          to,
        },
      },
    });
  };
export const onBoardingSummaryDownload =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<any> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/onboardingSummary`,
        method: 'GET',
        types: [ONBOARDING_SUMMARY_REPORT_DOWNLOAD, ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS],
        params: { ...params, from, to, downloadFile: params.downloadFile },
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };
export const onBoardingDetailsDownload =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<any> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/onboardingDetails`,
        method: 'GET',
        types: [ONBOARDING_DETAIL_REPORT_DOWNLOAD, ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS],
        params: {
          ...params,
          from,
          to,
          downloadFile: params.downloadFile,
        },
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const getOnBoardingCompletedDetails =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<GetOnboardingDetailsReportResponse> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/monthAndCustodianWiseCompletedApplications`,
        method: 'GET',
        types: [ONBOARDING_COMPLETED_DETAIL_REPORT, ONBOARDING_COMPLETED_DETAIL_REPORT_SUCCESS],
        params: {
          // ...params.omit('investorType'),
          from,
          to,
        },
      },
    });
  };

export const pennyDropReportDownload =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<any> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/pennyDropLogs`,
        method: 'GET',
        types: [PennyDropLogs_REPORT_Download, PennyDropLogs_REPORT_Download_SUCCESS],
        params: {
          // ...params,
          from,
          to,
          downloadFile: params.downloadFile,
        },
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };
export const onBoardingCompletedDetailsDownload =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<any> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/monthAndCustodianWiseCompletedApplications`,
        method: 'GET',
        types: [
          ONBOARDING_COMPLETED_DETAIL_REPORT_DOWNLOAD,
          ONBOARDING_COMPLETED_DETAIL_REPORT_DOWNLOAD_SUCCESS,
        ],
        params: {
          // ...params,
          from,
          to,
          downloadFile: params.downloadFile,
        },
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const onBoardingDetailsDownloadAllFields =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<any> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/allApplicationsData`,
        method: 'GET',
        types: [
          ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL,
          ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS,
        ],
        params: {
          ...params,
          from,
          to,
          downloadFile: params.downloadFile,
        },
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const distributorWiseOnBoardingSummaryDownload =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<any> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/distributorWiseOnboardingSummary`,
        method: 'GET',
        types: [
          DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD,
          DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS,
        ],
        params: {
          ...params,
          from,
          to,
          downloadFile: params.downloadFile,
        },
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };
export const distributorWiseCommitmentAmountDownload =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<any> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/distributorWiseCommitmentAmount`,
        method: 'GET',
        types: [
          DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD,
          DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS,
        ],
        params: {
          ...params,
          from,
          to,
          downloadFile: params.downloadFile,
        },
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };
export const getDistributorWiseCommitmentAmount =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<GetDistributorCommitmentAmount[]> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/distributorWiseCommitmentAmount`,
        method: 'GET',
        types: [DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT, DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS],
        params: {
          ...params,
          from,
          to,
        },
      },
    });
  };

export const getCompletedApplications =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<GetOnboardingCompletedDetailsReportResponse> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/completedApplications`,
        method: 'GET',
        types: [
          DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT,
          DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS,
        ],
        params: {
          ...params,
          limit: 10,
          sort: 'applicationNumber',
          order: 'DESC',
          from,
          to,
        },
      },
    });
  };

export const distributorOnboardingCompletedDownload =
  (params: ReportFilterType) =>
  async (dispatch: any): Promise<any> => {
    const { from, to } = updatedFromAndToDates(params);
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/completedApplications`,
        method: 'GET',
        types: [ONBOARDING_COMPLETED_REPORT_DOWNLOAD, ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS],
        params: {
          ...params,
          from,
          to,
          downloadFile: params.downloadFile,
        },
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };
